import React from 'react';
import { FadeLoader } from 'react-spinners';
import './Spinner.css';

export function Spinner({ isLoading }) {

    return (
        <div className='loader'>
            <FadeLoader
                color='#861818'
                loading={isLoading}
                size={100}
                speedMultiplier={1}
            />
        </div>
    );
}